import React, {cloneElement} from 'react';
import './index.css';
import classnames from 'classnames';
import {facialZones} from '../../../../../utils/skincareUtils';
import {customizeMargin} from './config';

export default function SimulationDisplayFixedArch({
  isLandscape = false,
  primaryColor = '#333',
}) {
  return (
    <div
      className="simulationpreview-display-section"
      style={{bottom: isLandscape ? '80px' : '50px'}}
    >
      <div
        className={classnames({
          'simulationpreview-archbase': true,
          'simulationpreview-archbase-landscape': isLandscape,
        })}
      >
        {facialZones.slice(0, -1).map((zone, index) => {
          const margin = customizeMargin[5][index] || '7px';
          return (
            <div
              className={classnames({
                'simulationpreview-facialzones-selector': true,
                'simulationpreview-facialzones-selector-zone':
                  zone.value !== 'face',
                'simulationpreview-facialzones-selector-zone-selected':
                  zone.value === 'face',
              })}
              style={{
                marginLeft: margin,
              }}
            >
              <div
                className={classnames({
                  'simulationpreview-facialzones-selector-img-outline': true,
                  'simulationpreview-facialzones-selector-img-outline-landscape': isLandscape,
                })}
              >
                <div
                  className={classnames({
                    'simulationpreview-facialzones-selector-img': true,
                    'simulationpreview-facialzones-selector-img-landscape': isLandscape,
                  })}
                >
                  {zone.icon_svg &&
                    cloneElement(zone.icon_svg, {
                      fill: zone.value === 'face' ? primaryColor : '#333',
                    })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
